import { Image, View } from "@react-pdf/renderer";
import React from "react";
import { useDocumentContext } from "../context";

export function Decoration() {
	/** Context */
	const context = useDocumentContext();

	/** Guard */
	if (!context.letterPaperUrl) return null;

	/** Render */
	return (
		<React.Fragment>
			<View
				style={{
					position: "absolute",
					left: 0,
					top: 0,
					right: 0,
					bottom: 0,
					zIndex: -1,
				}}
				fixed
			>
				<Image
					style={{
						width: "100%",
						height: "100%",
						objectFit: "cover",
					}}
					src={context.letterPaperUrl}
				/>
			</View>
		</React.Fragment>
	);
}
